module.exports = __webpack_public_path__ + "media/media/about/1-531ccdbae47077d59139dff65d8d38fb.jpg";